import { ITheme } from "constants/interfaces/theme.interface";

const Common = {
  TEXT_COLOR_DARK: "#000000",
  TEXT_COLOR_LIGHT: "#FFFFFF",
};

export const DarkTheme: ITheme = {
  mode: "dark",

  BUTTON: {
    BACKGROUND: {
      PRIMARY: "#FF851B",
      SECONDARY: "#121212",
      SUCCESS: "#D4EDDA",
      WARNING: "#856404",
      DANGER: "#CF6679",
      INFO: "#2a1ab9",
      LIGHT: "#FFFFFF",
      DARK: "#000000",
    },
    TEXT: {
      PRIMARY: "#000",
      SECONDARY: "#F5F5F5",
      SUCCESS: "#000000",
      WARNING: "#FFFFFF",
      DANGER: "#000000",
      INFO: "#FFFFFF",
      LIGHT: "#000000",
      DARK: "#FFFFFF",
    },
  },

  ALERT: {
    TEXT: {
      ERROR: "#000000",
      INFO: "#FFFFFF",
      SUCCESS: "#000000",
      WARNING: "#FFFFFF",
    },
    BACKGROUND: {
      ERROR: "#CF6679",
      INFO: "#2a1ab9",
      SUCCESS: "#D4EDDA",
      WARNING: "#856404",
    },
    ICON: {
      ERROR: "#812325",
      INFO: "#d7d6e6",
      SUCCESS: "#155724",
      WARNING: "#FFF3CD",
    },
  },

  CARD: {
    TEXT: {
      TITLE: "#FFFFFF",
      TEXT: "#F3F3F3",
    },
    BACKGROUND: "#161B22",
  },

  SELECT: {
    CLEAR_INDICATOR: {
      COLOR: "#000000",
    },
    INPUT: {
      BACKGROUND: "#161B22",
      COLOR: "#000000",
    },
  },

  TEXT: {
    DARK: Common.TEXT_COLOR_DARK,
    LIGHT: Common.TEXT_COLOR_LIGHT,
    PRIMARY: "#F5F5F5",
    SECONDARY: "#FFFFFF",
    TITLE: "#FFFFFF",
    NAVLINK: "#FFFFFF",
  },

  NAVBAR: {
    BACKGROUND: "#000",
  },

  FOOTER: {
    BACKGROUND: "#000",
  },

  BACKGROUND: {
    PRIMARY: "#212529",
    SURFACE: "#161B22",
  },

  INPUT: {
    BACKGROUND: "#161B22",
    DISABLED_BACKGROUND: "#161310",
    TEXT_COLOR: "#ffffff",
  },

  CHOOSEN: {
    SELECT_BACKGROUND : "#161B22",
    SELECT_COLOR : "#ffffff",
    MENU_BACKGROUND : "#161B22",
    MENU_COLOR : "#ffffff",
    MENU_COLOR_FOCUS : "#495057",
    MENU_BACKGROUND_FOCUS : "#52525E",
    SINGLE_COLOR : "ffffff"
  },



  // THEME COLORS
  PRIMARY_COLOR: "#161B22",
  COLOR_ACCENT: "#FF851B",
  BOX_SHADOW: "rgba(255, 255, 255, 0.03)",
  DIVIDER_COLOR: "rgba(255, 255, 255, 0.12)",
  ERROR_COLOR: "#CF6679",
};

export const LightTheme: ITheme = {
  mode: "light",

  BUTTON: {
    TEXT: {
      PRIMARY: "#FFF",
      SECONDARY: "#000",
      SUCCESS: "#000000",
      WARNING: "#000000",
      DANGER: "#FFFFFF",
      INFO: "#000000",
      LIGHT: "#000000",
      DARK: "#FFFFFF",
    },
    BACKGROUND: {
      PRIMARY: "#0c549c",
      SECONDARY: "#FFFFFF",
      SUCCESS: "#D4EDDA",
      WARNING: "#FFF3CD",
      DANGER: "#B00020",
      INFO: "#81c5ce",
      LIGHT: "#FFFFFF",
      DARK: "#000000",
    },
  },

  ALERT: {
    TEXT: {
      ERROR: "#FFFFFF",
      INFO: "#FFFFFF",
      SUCCESS: "#000000",
      WARNING: "#000000",
    },
    BACKGROUND: {
      ERROR: "#B00020",
      INFO: "#81c5ce",
      SUCCESS: "#D4EDDA",
      WARNING: "#856404",
    },
    ICON: {
      ERROR: "#FFFFFF",
      INFO: "#856404",
      SUCCESS: "#155724",
      WARNING: "#FFF3CD",
    },
  },

  CARD: {
    TEXT: {
      TITLE: "#000000",
      TEXT: "#5f6368",
    },
    BACKGROUND: "#FFFFFF",
  },

  SELECT: {
    CLEAR_INDICATOR: {
      COLOR: "#000000",
    },
    INPUT: {
      BACKGROUND: "#F5F5F5",
      COLOR: "#000000",
    },
  },

  TEXT: {
    DARK: Common.TEXT_COLOR_DARK,
    LIGHT: Common.TEXT_COLOR_LIGHT,
    PRIMARY: "#5f6368",
    SECONDARY: "#000000",
    TITLE: "#000000",
    NAVLINK: "#FFF",
  },

  NAVBAR: {
    BACKGROUND: "#092039",
  },

  FOOTER: {
    BACKGROUND: "#092039",
  },

  BACKGROUND: {
    PRIMARY: "#FFFFFF",
    SURFACE: "#F5F5F5",
  },

  INPUT: {
    BACKGROUND: "#F5F5F5",
    DISABLED_BACKGROUND: "#e9ecef",
    TEXT_COLOR: "#495057",
  },

  CHOOSEN: {
    SELECT_BACKGROUND : "#F5F5F5",
    SELECT_COLOR : "#495057",
    MENU_BACKGROUND : "#F5F5F5",
    MENU_COLOR : "#F5F5F5",
    MENU_COLOR_FOCUS : "#495057",
    MENU_BACKGROUND_FOCUS : "#E0E0E6",
    SINGLE_COLOR : "F5F5F5"
  },

  // THEME COLORS
  PRIMARY_COLOR: "#FFFFFF",
  COLOR_ACCENT: "#0c549c",
  BOX_SHADOW: "rgba(0, 0, 0, 0.15)",
  DIVIDER_COLOR: "#E5E5E5",
  ERROR_COLOR: "#B00020",
};
